/**
 * Hero section: the guest's name as the page's single <h1>.
 *
 * The monogram/initials badge is intentionally not shown — hidden per
 * explicit instruction. `getInitials()` (src/utils/text.js) still exists;
 * re-enable by rendering a `<div className="ceremony-hero__badge"
 * aria-hidden="true"><span>{getInitials(name)}</span></div>` above the
 * name (see git history for the exact markup this replaced).
 *
 * Check-in status is also intentionally not shown here — see
 * StatusBadge.js, which is kept but unused: re-enable by rendering
 * <StatusBadge isCheckedIn={...} /> below the name if it's ever wanted
 * again.
 *
 * `dir="auto"` lets the browser pick RTL/LTR per the actual name text,
 * so Arabic and English names both render correctly with no i18n library.
 */
export default function CeremonyHero({ name }) {
  return (
    <header className="ceremony-hero">
      <h1 className="ceremony-hero__name" dir="auto">
        {name}
      </h1>
      <p className="ceremony-hero__subtitle">أنتم مدعوون للاحتفال معنا</p>
    </header>
  );
}
